import { Component, input, InputSignal } from '@angular/core';
import { IconImports } from '@core/modules/components/icon/icon.imports';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'svg-icon',
  standalone: true,
  templateUrl: './icon.component.html',
  // eslint-disable-next-line @angular-eslint/component-max-inline-declarations
  styles: [
    `
      .icon {
        display: inline-block;
        vertical-align: top;
        fill: currentColor;
      }
    `,
  ],
  imports: IconImports,
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class SvgIcon {
  public size: InputSignal<number> = input<number>(16);
  public name: InputSignal<string> = input<string>('');
}
